import { render } from "./App_Date_Input.vue?vue&type=template&id=5384a883&scoped=true"
import script from "./App_Date_Input.vue?vue&type=script&lang=js"
export * from "./App_Date_Input.vue?vue&type=script&lang=js"

import "./App_Date_Input.vue?vue&type=style&index=0&id=5384a883&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5384a883"]])

export default __exports__